import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <footer className="admin-layout-footer admin-footer footer">
        <div className="container-fluid">
          <div className="d-sm-flex justify-content-center justify-content-sm-between py-2 w-100">
            <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">
              Copyright &copy; <a href="https://hiplay.in/" target="_blank" rel="noopener noreferrer">Hiplay Battle Pvt Ltd.</a> {new Date().getFullYear()}
            </span>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
